import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import fi from '../locales/fi.json';
import type { Locale } from './api';

/**
 * Finnish and English from day one (D12).
 *
 * accounts.puida.com issues no `locale` claim, so Sulje stores the choice on
 * the account (§8.1). Before /v1/me has answered — and on the landing page,
 * where there is no account — the browser's language decides.
 */
export const LOCALES: readonly Locale[] = ['en', 'fi'];

export function browserLocale(): Locale {
  const lang = globalThis.navigator?.language?.toLowerCase() ?? 'en';
  return lang.startsWith('fi') ? 'fi' : 'en';
}

export const i18n = createI18n({
  legacy: false,
  locale: browserLocale(),
  fallbackLocale: 'en',
  messages: { en, fi },
});

export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
}
